





















import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({})
export default class OpeningHours extends Vue {
    @State("openingHours")
    public openingHours: any;
}
